<template>
  <!-- Column container -->
  <div class="z-5 w-full pt-20">
    <!-- One Column for Educator Pages -->
    <main
      id="main"
      tabindex="-1"
      class="flex flex-col w-full h-auto px-4 xl:px-8 mx-auto xl:max-w-7xl"
    >
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
// Navigation is now handled at the App.vue level
</script>